@import '../../../../../../../constants/spacing.module.less';

.plan-tag(@border, @background, @color) {
  padding: @space-4 @space-8;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  width: fit-content;

  border: 1px solid @border;
  background: @background;
  color: @color;
}

.current-tag {
  .plan-tag(
    @border: var(--gray-212c36);
    @background: var(--gray-F1F2F3);
    @color: var(--gray-0F0F10);
  );
}

.recommended-tag {
  .plan-tag(
    @border: var(--blue-1D5AD8);
    @background: var(--blue-EDF6FF);
    @color: var(--blue-1D5AD8);
  );

  &.is-selected {
    background: var(--blue-1D5AD8);
    color: var(--white);
  }
}

.promotional-tag {
  .plan-tag(
    @border: var(--purple-8D30F7);
    @background: var(--purple-F6F2FF);
    @color: var(--purple-8D30F7);
  );
}
